// /src/utils/commonDataUtils.ts
import config from "../config.json";
import { fetchCountries } from "../services/CountryService";
import { fetchOperators } from "../services/OperatorsService";
import { IPageable, Option } from "../types/table/interfaces.type";

/**
 * Load all countries as an array of { label, value } options.
 */
export async function loadCountriesOptions(): Promise<Option[]> {
  const countriesPage = await fetchCountries({
    sort: "name",
    size: config.MAX_PAGE_SIZE,
  });
  return pageAsOptions(countriesPage);
}

/**
 * Given a countryId, fetch all operators for that country and return as options.
 */
export async function loadOperatorsByCountry(
  countryId: number
): Promise<Option[]> {
  const operators = await fetchOperators({
    countryId,
    size: config.MAX_PAGE_SIZE,
  });
  return operators.content.map((operator) => ({
    label: operator.name,
    value: operator.id,
  }));
}

/**
 * Convert a paged response into options.
 */
export function pageAsOptions(
  page: IPageable<{ id: any; name: string }>
): Option[] {
  return arrayAsOptions(page.content);
}

/**
 * Convert a simple array of { id, name } objects into options.
 */
export function arrayAsOptions<T extends { id: any; name: string }>(
  arr: T[]
): Option[] {
  return arr.map((element) => ({
    label: element.name,
    value: element.id,
  }));
}
